import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Editor from "@/components/Editor";
export default {
  name: "addSwiper",
  components: {
    Editor: Editor
  },
  data: function data() {
    return {
      form: {
        id: "",
        title: "",
        img: "",
        language: ""
      },
      dialogShow: false,
      img: [],
      rules: {
        language: [{
          required: true,
          message: "请选择语言",
          trigger: "blur"
        }],
        img: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: "请上传图片",
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (data) {
                  _this.form = _objectSpread({}, data);
                  _this['img'] = data.img ? [data.img] : [];
                }

                _this.dialogShow = true;

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    imgChange: function imgChange(e, type) {
      this[type] = e;
      this.form[type] = e[0] && e[0].response ? e[0].response.data : '';
    },
    onEditorChange: function onEditorChange(e) {
      this.form.describe = e;
    },
    hide: function hide() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.form = {
        id: type ? this.form.id : "",
        name: "",
        img: "",
        language: "",
        title: ""
      };
      this.img = [], this.$refs.ruleForm.resetFields();
    },
    submitData: function submitData() {
      var _this2 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var data = JSON.parse(JSON.stringify(_this2.form));
          var reqFn = _this2.form.id ? 'heroSlideshowUpdate' : 'heroSlideshowAdd';

          _this2.$api[reqFn](data).then(function (res) {
            if (res.code == 0) {
              _this2.$message({
                message: '操作成功',
                type: 'success'
              });

              _this2.hide();

              _this2.$emit('change');
            }
          });
        }
      });
    }
  }
};